/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const HeroiconsSolidWrenchScrewdriver = ({ className }) => {
  return (
    <svg
      className={`heroicons-solid-wrench-screwdriver ${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        clipRule="evenodd"
        d="M12 6.75C12 3.85051 14.3505 1.5 17.25 1.5C17.7791 1.5 18.2913 1.57852 18.7747 1.72505C19.027 1.80151 19.2206 2.00479 19.2847 2.26048C19.3488 2.51618 19.2739 2.78674 19.0875 2.97313L15.7688 6.29183C15.8305 6.76741 16.0438 7.22581 16.409 7.59099C16.7742 7.95617 17.2326 8.16947 17.7082 8.23117L21.0269 4.91247C21.2133 4.72608 21.4838 4.65122 21.7395 4.7153C21.9952 4.77938 22.1985 4.97299 22.275 5.22526C22.4215 5.7087 22.5 6.22086 22.5 6.75C22.5 9.64949 20.1495 12 17.25 12C17.0995 12 16.9503 11.9936 16.8027 11.9812C15.7855 11.8952 14.9338 12.0816 14.4944 12.6151L7.34327 21.2987C6.71684 22.0593 5.78308 22.5 4.79769 22.5C2.97642 22.5 1.5 21.0236 1.5 19.2023C1.5 18.2169 1.94067 17.2832 2.70132 16.6567L11.3849 9.50557C11.9184 9.06623 12.1048 8.21453 12.0188 7.19728C12.0064 7.04968 12 6.9005 12 6.75ZM4.11723 19.125C4.11723 18.7108 4.45302 18.375 4.86723 18.375H4.87473C5.28895 18.375 5.62473 18.7108 5.62473 19.125V19.1325C5.62473 19.5468 5.28895 19.8825 4.87473 19.8825H4.86723C4.45302 19.8825 4.11723 19.5468 4.11723 19.1325V19.125Z"
        fill="#7041F1"
        fillRule="evenodd"
      />
      <path
        className="path"
        d="M10.076 8.64031L7.87502 6.43936V4.87502C7.87502 4.61157 7.73679 4.36744 7.51089 4.2319L3.76089 1.9819C3.46578 1.80483 3.08804 1.85133 2.84469 2.09469L2.09469 2.84469C1.85133 3.08804 1.80483 3.46578 1.9819 3.76089L4.2319 7.51089C4.36744 7.73679 4.61157 7.87502 4.87502 7.87502H6.43936L8.50138 9.93704L10.076 8.64031Z"
        fill="#7041F1"
      />
      <path
        className="path"
        clipRule="evenodd"
        d="M12.5559 17.3287L16.7386 21.5114C18.0567 22.8294 20.1936 22.8294 21.5116 21.5114C22.8296 20.1934 22.8296 18.0565 21.5116 16.7385L18.206 13.4328C17.8937 13.4771 17.5746 13.5 17.2501 13.5C17.0574 13.5 16.866 13.4918 16.6765 13.4758C16.2822 13.4425 15.994 13.4696 15.8089 13.5177C15.7053 13.5446 15.6574 13.5713 15.6419 13.5814L12.5559 17.3287ZM15.9698 15.9697C16.2627 15.6768 16.7375 15.6768 17.0304 15.9697L18.9054 17.8447C19.1983 18.1376 19.1983 18.6124 18.9054 18.9053C18.6125 19.1982 18.1377 19.1982 17.8448 18.9053L15.9698 17.0303C15.6769 16.7374 15.6769 16.2626 15.9698 15.9697Z"
        fill="#7041F1"
        fillRule="evenodd"
      />
    </svg>
  );
};
